import { QuestionType, TestModuleQuestionResponse } from '@/api/services/types/questionTypes'
import { GoNoGoTask } from '@/views/tasks/gonogo/GoNoGoTask'
import MultipleQuestionTask from '@/views/tasks/multiple_choice_question/MultipleQuestionTask'
import { WorkingMemoryTask } from '@/views/tasks/working_memory/WorkingMemoryTask'
import LikertScaleQuestionTask from '@/views/tasks/likert_scale_question/LikertScaleQuestionTask'
import AttentionTask from '@/views/tasks/attention/AttentionTask'
import { SequenceTask } from '@/views/tasks/sequencing/components/SequenceTask'
import { BalloonRiskTask } from '@/views/tasks/baloon_risk/BaloonRiskTask'
import { IowaGamblingTask } from '@/views/tasks/iowa_gambling/IowaGamblingTask'
import { CognitiveFlexibilityTask } from '@/views/tasks/cognitive_flexibility/CognitiveFlexibilityTask'
import { OpenQuestionTask } from '@/views/tasks/open-question/OpenQuestionTask'
import { ImageMatchingTask } from '@/views/tasks/graphic_matching/ImageMatchingTask'
import { LogicalChoiceGraphicsTask } from '@/views/tasks/logical_choice_graphics/LogicalChoiceGraphicsTask'

interface TaskProps {
  type: QuestionType
  data: TestModuleQuestionResponse
  moduleId: string
  questionId: string
  onNext: () => void
  onStart: () => void
}

export default function CurrentTask({ type, data, moduleId, questionId, onNext, onStart }: TaskProps) {
  switch (type) {
    case QuestionType.OPEN_QUESTION:
      return <OpenQuestionTask 
      key={data.id}
      questionId={questionId} moduleId={moduleId} data={[data.openQuestion!!]} 
      onComplete={onNext}
      onStart={onStart}
      />
    case QuestionType.MULTIPLE_CHOICE_QUESTION:
      if (!data.multipleChoiceQuestion) return null
      return (
        <MultipleQuestionTask
        key={data.id}
          data={data.multipleChoiceQuestion}
          moduleId={moduleId}
          questionId={questionId}
          onComplete={onNext}
          onStart={onStart}
        />
      )
    case QuestionType.MEMORY_TASK:
      return <WorkingMemoryTask
      key={data.id}
      data={data.memoryTask!!}
      questionId={data.questionId}
moduleId={data.testModuleId}
      onComplete={onNext} onStart={onStart} />
    case QuestionType.LIKERT_SCALE_QUESTION:
      return <LikertScaleQuestionTask key={data.id} moduleId={data.testModuleId} questionId={data.questionId} data={data.likertScaleQuestion!!} onComplete={onNext} onStart={onStart} />
    case QuestionType.ATTENTION_TASK:
      return (
        <AttentionTask
        key={data.id}
          data={data.attentionTask!}
          moduleId={moduleId}
          questionId={questionId}
          onComplete={onNext}
          onStart={onStart}
        />
      )
    case QuestionType.SEQUENCING_TASK:
      if (!data.sequencingTask) return null
      return (
        <SequenceTask
        key={data.id}
          data={data.sequencingTask}
          moduleId={data.testModuleId}
          questionId={data.questionId}
          timeLimitSeconds={data.sequencingTask.timeLimitSeconds}
          onComplete={onNext}
          onStart={onStart}
        />
      )
    case QuestionType.BALLOON_ANALOGUE_RISK_TASK:
      if (!data.balloonAnalogueRiskTask) return null
      return (
        <BalloonRiskTask
        key={data.id}
        moduleId={moduleId}
        questionId={questionId}
        data={data.balloonAnalogueRiskTask}
          onComplete={onNext}
          onStart={onStart}
        />
      )
    case QuestionType.IOWA_GAMBLING_TASK:
      if (!data.iowaGamblingTask) return null
      return (
        <IowaGamblingTask
        key={data.id}
        data={data.iowaGamblingTask}
        moduleId={moduleId}
        questionId={questionId}
          onComplete={onNext}
          onStart={onStart}
        />
      )
    case QuestionType.GO_NO_GO_TASK:
      if (!data.goNoGoTask) return null
      return (
        <GoNoGoTask
        key={data.id}
        data={data.goNoGoTask}
        moduleId={data.testModuleId}
        questionId={data.questionId}
          onComplete={onNext}
          onStart={onStart}
        />
      )
    case QuestionType.IMAGE_MATCHING_TASK:
      return <ImageMatchingTask
      key={data.id}
      isDraggable={data.imageMatchingTask?.matchingMode === "DRAG"}
      onComplete={onNext} onStart={onStart} />
    case QuestionType.COGNITIVE_FLEXIBILITY_TASK:
      return <CognitiveFlexibilityTask
      moduleId={moduleId}
      questionId={questionId}
      data={data.cognitiveFlexibilityTask!!}
      onComplete={onNext} onStart={onStart} />
      case QuestionType.LOGICAL_ODD_ONE_OUT_TASK:
        return <LogicalChoiceGraphicsTask
        moduleId={moduleId}
        questionId={questionId}
        data={data.logicalOddOneOutTask!!}
        onStart={onStart}
        onComplete={onNext}

        />
    default:
      return <div>Nieznany typ zadania: {type}</div>
  }
} 